import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService } from '../../services/tools/helpers.service';
import { ConveniosService } from '../../services/convenios.service';
import { ArchivosConveniosService } from '../../services/archivos-convenios.service';

@Component({
    selector: 'convenios-detalles',
    templateUrl: './convenios-detalles.component.html',
    styleUrls: ['./convenios-detalles.component.scss']
  })

export class ConveniosDetallesComponent implements OnInit {
    //Constants
    private tipoCredito = 4;
    //UI
    public convenio : any = {};
    public archivos : any [] = [];
    public errors:any = {};
    //Subscriptions
    private sub: any;
    //Edit mode
    public id : number = null;
    //Tipo de convenio
    public tipoSelected:any = {id:null};
    public tipoConDefault = "";
    public optTipoCon = [{id:1, nombre:"Nómina"},{id:2, nombre:"Hipotecario"},{id:3, nombre:"Automotriz"},{id:4, nombre:"Prendario"},{id:5, nombre:"Verde"},
    {id:6, nombre:"Personal"},{id:7, nombre:"Credigas Carburación"},{id:8, nombre:"Credigas Estacionario"},{id:9, nombre:"Comercialización"},{id:10, nombre:"Maxi Pensión"}];

    constructor(
      private helperService : HelpersService,
      public location : Location,
      private activeRoute : ActivatedRoute,
      private router : Router,
      private conveniosService : ConveniosService,
      private archivosService : ArchivosConveniosService
    ){
    }

    public ngOnInit() {
      this.sub = this.activeRoute.params.subscribe(params => {
        if(params['id']){
            //Edit mode
            this.id = params['id'] ? +params['id'] : 0; // (+) converts string 'id' to a number
            this.getConvenio(this.id);
        } 
      }); 
    }

    tipoChanged(tipo){
      console.log("Event Estado: ", tipo);
      
      if(tipo){
          this.tipoSelected = tipo;
          this.convenio.tipo_convenio = this.tipoSelected.nombre;
          console.log("Tipo convenio: ",this.convenio);
          // this.getGastosPorMes();
      }else{
        this.tipoSelected = this.optTipoCon[0];
        this.convenio.tipo_convenio = this.tipoSelected.nombre;
      }
    }
    private selectTipo(tipo){
      this.tipoSelected = this.optTipoCon[0];
      this.convenio.tipo_convenio = this.tipoSelected;
      for (let index = 0; index < this.optTipoCon.length; index++) {
        const element = this.optTipoCon[index];
        if(element.nombre === tipo){
          this.tipoSelected = this.optTipoCon[index];
          this.convenio.tipo_convenio = tipo;
          break;
        }
        
      }
    }

    private getConvenio(idCredito : number){
      
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.conveniosService.get(idCredito).subscribe(
        (response)=>
        {
          this.convenio = response.json().content;
          this.selectTipo(this.convenio.tipo_convenio)
          console.log(this.convenio);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public save(){
      this.errors = {};
      
      let convenio = this.convenio;

      this.errors = this.conveniosService.validate(convenio);
      if (Object.entries(this.errors).length > 0) {
        return false;
      }
      if(convenio.id){
        //Update credito
        this.update(convenio);
      }else{
        //New credito
        if(this.archivos.length > 0){
          //Si se agregaron archivos al convenio es necesario enviar sus ids, para actualizar su estatus (se guardan como temporales)
          convenio.archivos = this.archivos;
        }

        this.create(convenio);
      }
  }

  private create(convenio : any){
    this.conveniosService.save(convenio).subscribe(
      (response)=>
      {
        const result = response.json().content;
        //Navigate to tabla de amortizacion
        this.helperService.notification('Convenio creado', 'Se ha registrado exitosamente la información del convenio ', 'success');
        this.router.navigate(['/convenios']);
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.helperService.showSaveCreditErrors(error.json().content, this.errors);
        }
      }
    );
  }

  private update(credito : any){
    this.conveniosService.update(this.convenio).subscribe(
      (response)=>
      {
        const result = response.json().content;
        //Navigate to tabla de amortizacion
        this.helperService.notification('Convenio actualizado', 'Se ha actualizado exitosamente la información del convenio ', 'success');
        this.router.navigate(['/convenios']);
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.helperService.showSaveCreditErrors(error.json().content, this.errors);
        }
      }
    );
  }

  public onUploadFile(archivo : any){
    //Solo se necesita llevar un control de los archivos cuando es un convenio nuevo
    if(!this.id){
      this.archivos.push(archivo.id);
    }
  }

  public onDeleteFile(archivo : any){
    //Solo se necesita llevar un control de los archivos cuando es un convenio nuevo
    if(!this.id){
      let indexToDelete = null;
      this.archivos.forEach(function(idArchivo, index) {
        
        if(archivo.id === idArchivo){
          indexToDelete = index;
        }
      });

      //Cuando se borra un archivo, se debe de elimiar el item correspondiente en el arreglo. Puesto que este item ya se borro de la BD
      if(indexToDelete !== null){
        this.archivos.splice(indexToDelete, 1);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/convenios/detalles/convenios-detalles.component.ts